import { CanvasRoutes } from '@/configs/routes/types';

export const ExploreRoutes = {
  [CanvasRoutes.Explore]: {
    name: 'Explore',
    path: '/explore',
    showInNavigation: true,
    showInBreadcrumbs: false,
  },
  [CanvasRoutes.Search]: {
    name: 'Search',
    path: '/explore/search',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
};
